import { Button } from "@tine/designsystem-ui-react";
import { cn } from "@tine/designsystem-utils";
import { observer } from "mobx-react-lite";
import { ENV_NAME } from "../../../common/environment";
import { getCaptureConfig, getCaptureMappings } from "../../../common/utils/dynamicsUtils";
import authStore from "../../../stores/auth/authStore";
import loginState from "../../../stores/auth/loginState";
import promotionStore from "../../../stores/promotionStore";
import SignupForm from "../../common/signup/SignupForm";
import ValidatedCheckbox from "../../formvalidation/ValidatedCheckbox";
import AdventCalendarTermsAndConditionsLinks from "./AdventCalendarTermsAndConditionsLinks";
import type { AdventCalendarCampaign } from "./adventCalendarUtils";

export const classNameChristmasButton =
   "[&_button]:bg-christmasButton [&_button]:border-christmasButton [&_button]:text-ink-brand-inverted [&_button:hover]:bg-christmasButtonHover [&_button:hover]:border-christmasButtonHover";
const classNameInputHover = "[&_input:hover]:border-christmasButton [&_.group:hover_input]:border-christmasButton";
const classNameCheckboxChecked =
   "[&_input[type='checkbox']:checked:hover]:bg-christmasButtonHover [&_input[type='checkbox']:checked:hover]:border-christmasButtonHover";
const classNameCheckboxCheckedHover =
   "[&_input[type='checkbox']:checked]:bg-christmasButton [&_input[type='checkbox']:checked]:border-christmasButton";
const classNameCheckboxGroupHover =
   "[&_.group:hover_input[type='checkbox']:checked]:bg-christmasButtonHover [&_.group:hover_input[type='checkbox']:checked]:border-christmasButtonHover";

type AdventCalendarReminderFormProps = { campaign: AdventCalendarCampaign };

const AdventCalendarReminderForm = observer(({ campaign }: AdventCalendarReminderFormProps) => {
   const company = authStore.getCurrentCompany();
   const isLoggedIn = authStore.isLoggedIn();

   const values = {
      company: company?.customerNumber || "",
      description:
         ENV_NAME === "prod" ? `TH Julekalender ${campaign.year} - påmelding` : `Påmelding Julekalender ${campaign.year}`
   };

   const handleSignup = (payload: Record<string, string>) => {
      promotionStore.signUpToPromotion(campaign.reminderSignUpCode, "", "", payload);
   };
   return (
      <div
         className={cn(
            "flex flex-col gap-4 items-center pb-4 w-full max-w-md",
            classNameChristmasButton,
            classNameInputHover,
            classNameCheckboxChecked,
            classNameCheckboxCheckedHover,
            classNameCheckboxGroupHover
         )}
      >
         {isLoggedIn ? (
            <SignupForm
               buttonText="Meld deg på"
               config={getCaptureConfig("main")}
               mappings={getCaptureMappings("main")}
               onSignup={handleSignup}
               values={values}
               trackingFormName="Epost-påmelding julekalender"
               persistenceKey={`advent-calendar-form-${campaign.year}`}
            >
               <ValidatedCheckbox
                  name="consent"
                  label={<AdventCalendarTermsAndConditionsLinks year={campaign.year} />}
                  initialValue={false}
                  required
               />
            </SignupForm>
         ) : (
            <Button variant="secondary" onClick={() => loginState.transitionToIfPossible("LOGIN_MODAL")}>
               Logg inn for å melde deg på
            </Button>
         )}
      </div>
   );
});

export default AdventCalendarReminderForm;
